import queryString from 'query-string'
import 'nodelist-foreach-polyfill'
import 'formdata-polyfill'

const orderSelects = document.querySelectorAll('.js-order')

orderSelects.forEach((el) => {
  el.addEventListener('change', (e) => changeOrderPer(e.target.value, 'order'))
})

const changeOrderPer = (value, type) => {
  const params = queryString.parse(location.search.substr(1), { arrayFormat: 'bracket' })
  params[type] = value
  const query = queryString.stringify(params, { arrayFormat: 'bracket' })
  const url = [location.protocol, '//', location.host, location.pathname, '?', query].join('')
  window.location.href = url
}
